module.exports = __webpack_public_path__ + "static/stars-earth-dcd2bc1a187c5c5b896619a6efb259a9.jpg";